import { createTheme } from '@mui/material/styles'

const trainingColour = '#C85C17'
export default createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: trainingColour,
            '&:hover': { backgroundColor: trainingColour }
          }
        },
        today: { color: trainingColour, borderColor: trainingColour }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: { cursor: 'pointer' },
        input: { cursor: 'pointer', userSelect: 'none' }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
          '&:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
            borderColor: trainingColour
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: trainingColour }
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: { root: { '&.Mui-focused': { color: trainingColour } } }
    }
  }
})
